module.exports = __webpack_public_path__ + "img/efforts.2db0aa6f.svg";